import React, { ReactNode } from 'react';

interface DetailsViewProps {
  components: {
    DetailsViewContent: ReactNode;
  };
  properties: any;
  selectedTicket: any;
}

const DetailsView: React.FC<DetailsViewProps> = ({
  components,
  properties = {}
}) => {
  return (
    <div className="fh fw position-relative">
      <components.DetailsViewContent {...properties?.DetailsViewContent} />
    </div>
  );
};

DetailsView.defaultProps = {
  components: {
    DetailsViewContent: (props) => {
      return <div> DetailsViewContent No data</div>;
    }
  }
};

export default DetailsView;
